import React from 'react';
import { Helmet } from 'react-helmet-async';


import balakhninImg from '../images/balakhnin.png';
import gavrikovImg from '../images/gavrikov.png';
import sebrantImg from '../images/sebrant.png';

function AdmissionCommittee() {
  const committeeMembers = [
    {
      name: 'Илья Балахнин',
      image: balakhninImg,
      alt: 'Илья Балахнин',
      paragraphs: [
        'Илья Балахнин является признанным экспертом в области маркетинга, бизнес-стратегии и управления на основе данных. Он является основателем и управляющим партнером консалтингового агентства Paper Planes и обладает более чем 15-летним профессиональным опытом в области стратегического маркетинга, цифровой трансформации и развития бизнес-моделей.',
        'В рамках своей профессиональной деятельности Илья Балахнин реализовал значительное количество маркетинговых и стратегических проектов для компаний из различных отраслей и стран, оказывая влияние на развитие маркетинговых практик и повышение эффективности бизнеса. Он является автором профессиональных методологий и книг, посвященных маркетингу, продажам и управлению клиентским опытом, а его подход основан на глубокой аналитике данных и внедрении системных решений с измеримым результатом.',
        'Илья Балахнин активно участвует в развитии профессионального сообщества, выступает в качестве спикера на отраслевых и международных конференциях, а также реализует образовательные программы, направленные на подготовку специалистов в области маркетинга и бизнеса. Его деятельность, публикации и экспертный вклад получили широкое признание в профессиональной среде, что подтверждает его статус одного из ведущих специалистов в области современного маркетинга.'
      ]
    },
    {
      name: 'Андрей Гавриков',
      image: gavrikovImg,
      alt: 'Андрей Гавриков',
      paragraphs: [
        'Андрей Гавриков является признанным экспертом в области цифрового маркетинга и стратегического развития бизнеса, обладающим более чем 20-летним профессиональным опытом. Он является основателем и руководителем маркетинговой группы Completo, одной из известных компаний в сфере digital-маркетинга, реализующей комплексные проекты для крупных российских и международных брендов. В рамках своей деятельности он участвовал в реализации сотен маркетинговых проектов, направленных на развитие бизнеса, повышение эффективности маркетинговых инвестиций и внедрение современных цифровых решений.',
        'Профессиональная деятельность Андрея Гаврикова связана с разработкой и внедрением стратегических подходов в маркетинге, включая построение системного маркетинга, цифровую трансформацию компаний и оптимизацию бизнес-процессов. Он работал с крупными корпоративными клиентами и участвовал в проектах, оказывающих значительное влияние на развитие маркетинговых практик и повышение конкурентоспособности компаний. Его подход основан на сочетании аналитики, стратегического мышления и практической реализации решений с измеримыми бизнес-результатами.',
        'Андрей Гавриков активно участвует в развитии профессионального сообщества, выступая в качестве преподавателя, спикера и автора образовательных программ. Он сотрудничает с ведущими образовательными платформами и бизнес-школами, проводит обучение специалистов и предпринимателей, а также выступает на профильных конференциях и отраслевых мероприятиях. Его экспертная деятельность, публикации и образовательные инициативы получили признание в профессиональной среде, что подтверждает его статус одного из ведущих специалистов в области современного маркетинга.'
      ]
    },
    {
      name: 'Андрей Себрант',
      image: sebrantImg,
      alt: 'Андрей Себрант',
      paragraphs: [
        'Андрей Себрант является признанным экспертом в области цифрового маркетинга, технологий и стратегического развития. Он занимает руководящую позицию в компании Яндекс, где участвует в разработке и развитии цифровых продуктов, рекламных технологий и решений в области аналитики данных. Его профессиональная деятельность связана с развитием технологических и маркетинговых экосистем, а также внедрением современных подходов к взаимодействию с пользователями.',
        'На протяжении своей карьеры Андрей Себрант внес значительный вклад в развитие интернет-индустрии и цифрового маркетинга, включая участие в создании и развитии интернет-сервисов, аналитических инструментов и маркетинговых решений. Он является одним из заметных экспертов в области цифровой трансформации и интерактивного маркетинга, а также автором многочисленных публикаций и докладов, посвященных развитию технологий и маркетинговых практик.',
        'Андрей Себрант активно участвует в профессиональной и образовательной деятельности, выступает на международных и отраслевых конференциях, участвует в экспертных дискуссиях и профессиональных сообществах. Его опыт, уровень компетенций и признание со стороны профессиональной среды позволяют отнести его к числу ведущих специалистов, оказывающих существенное влияние на развитие цифрового маркетинга и технологий на национальном и международном уровнях.'
      ]
    }
  ];

  return (
    <div className="xContent p-box py-6">
      <Helmet>
        <title>Комитет по приему</title>
        <meta
          name="description"
          content="Члены Комитета по приему в члены ассоциации Международной Ассоциации Маркетологов СНГ"
        />
        <link rel="canonical" href="https://marketing-association.com/admission-committee" />
      </Helmet>

      <h1 className="title">Члены Комитета по приему в члены ассоциации Международной ассоциации маркетологов СНГ</h1>

      <div className="content p-20">
        <div className="committeeGrid">
          {committeeMembers.map((member, index) => (
            <section className="committeeCard" key={index}>
              <h2 className="committeeName">{member.name}</h2>

              <div className="committeePhotoWrap">
                <img
                  src={member.image}
                  alt={member.alt}
                  className="committeePhoto"
                />
              </div>

              <div className="committeeText">
                {member.paragraphs.map((paragraph, pIndex) => (
                  <p key={pIndex}>{paragraph}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdmissionCommittee;